import styled from 'styled-components';

import { style } from '@genially/design-system';

export const ContentWrapper = styled.div({
  position: 'relative',
  display: 'flex',
});

export const GameControlHeaderWrapper = styled.div({
  width: '100%',
  zIndex: 2,
  pointerEvents: 'none',
});

interface BannerWrapperProps {
  $show: boolean;
}

// Sits above the game control header, which is absolutely positioned at the top with zIndex 2.
export const BannerWrapper = styled.div<BannerWrapperProps>(({ $show }) => ({
  width: '100%',
  zIndex: 3,
  pointerEvents: $show ? 'auto' : 'none',
}));

// Holds everything the invite sidebar pushes aside: header, banner, overlay sidebars and
// content. Its own position:relative is what keeps those absolutely-positioned pieces from
// ever extending behind the invite sidebar. overflow:hidden clips the overlay sidebars'
// closed (translateX(-100%)) position, which would otherwise bleed left into the invite
// sidebar instead of landing off-canvas.
export const MainColumn = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',

  [ContentWrapper]: {
    flexGrow: 1,
  },

  [GameControlHeaderWrapper]: {
    position: 'absolute',
    top: 0,
    left: 0,
  },

  [BannerWrapper]: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
});

export const Wrapper = styled.div({
  display: 'flex',
});

export const PlaySidebarSummaryWrapper = styled.div({
  maxWidth: '40%',

  ...style.mixins.responsive.sm.downward({
    maxWidth: '100%',
  }),
});
